module.exports = __webpack_public_path__ + "youtube-9a71ed79879eaefe889b.svg";